import { combineEpics, ofType } from "redux-observable";
import { combineLatest, concat, from } from "rxjs";
import { filter, map, mapTo, retry, switchMap, take, takeUntil } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { guard } from "../../guards/guard";
import { actionModalOpen, TypeActionModal } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionNotEnoughResource, } from "../../not-enough-resource/actionNotEnoughResource";
import { IdMissingResourceTypes } from "../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../ongoing-purchase/actionOngoingPurchase";
import { TypeActionInventoryInfo } from "../inventory/actionInventoryInfo";
import { actionProductionBoost, actionProductionInfo, TypeActionProductionInfo, } from "./actionProductionInfo";
import { checkHasEnoughHumus } from "./checks/checkHasEnoughHumus";
import { checkHasEnoughResources } from "./checks/checkHasEnoughResources";
import { epicProductionAddOrUpdate } from "./epics/epicProductionAddOrUpdate";
import { epicProductionCanCollectProducts } from "./epics/epicProductionCanCollectProducts";
import { epicProductionCollectProduct } from "./epics/epicProductionCollectProduct";
import { epicProductionNotEnoughResources } from "./epics/epicProductionNotEnoughResources";
import { epicProductionSkip } from "./epics/epicProductionSkip";
import { epicProductionSkipConfirmed } from "./epics/epicProductionSkipConfirmed";
import { epicProductionSkipNotEnoughGold } from "./epics/epicProductionSkipNotEnoughGold";
import { pathBuyMissingResources } from "./path/pathBuyMissingResources";
import { pathNotEnoughHumus } from "./path/pathNotEnoughHumus";
import { pathProductionBoost } from "./path/pathProductionBoost";
import { pathProductionStart } from "./path/pathProductionStart";
var epicProductionInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAuth.Login), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.ProductionInfo,
            props: {
                playerId: action.playerId,
            },
        });
    }), retry(), map(function (res) { return actionProductionInfo(res); }));
};
var epicProductionStart = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionProductionInfo.Start), guard(state$, deps, pathProductionStart)([
        checkHasEnoughResources(pathBuyMissingResources),
    ]));
};
export var epicProductionBoost = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionProductionInfo.Boost), guard(state$, deps, pathProductionBoost)([checkHasEnoughHumus(pathNotEnoughHumus)]));
};
export var epicProductBoostNotEnoughCost = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionProductionInfo.BoostNotEnoughRecipeCost), switchMap(function (action) {
        var buyWithGoldCanceled$ = action$.pipe(filter(function (cancelAction) {
            return cancelAction.type === TypeActionNotEnoughResource.Cancel ||
                (cancelAction.type === TypeActionModal.CloseLast &&
                    cancelAction.modalId ===
                        IdModal.NotEnoughResource);
        }), take(1));
        var buyWithGoldPurchased$ = action$.pipe(ofType(TypeActionNotEnoughResource.BuyWithGoldComplete), takeUntil(buyWithGoldCanceled$), take(1), filter(function (notEnoughResourceAction$) {
            return notEnoughResourceAction$.isPurchased;
        }));
        var addResource$ = action$.pipe(ofType(TypeActionInventoryInfo.AddResource), takeUntil(buyWithGoldCanceled$), filter(function (addResourceAction) {
            return action.missingRecipeCost.some(function (missingItem) {
                return addResourceAction.items.some(function (addedItem) { return addedItem.typeId === missingItem.typeId; });
            });
        }), take(1));
        return concat(from([
            actionOngoingPurchaseStandardSelect([
                {
                    missingResources: action.missingRecipeCost,
                    missingType: IdMissingResourceTypes.Resources,
                },
            ]),
            actionModalOpen(IdModal.NotEnoughResource),
        ]), combineLatest(buyWithGoldPurchased$, addResource$).pipe(mapTo(actionProductionBoost(action.building, action.recipe))));
    }));
};
export var epicProduction = combineEpics(epicProductionAddOrUpdate, epicProductionInfo, epicProductionStart, epicProductionSkip, epicProductionBoost, epicProductBoostNotEnoughCost, epicProductionNotEnoughResources, epicProductionSkipNotEnoughGold, epicProductionSkipConfirmed, epicProductionCollectProduct, epicProductionCanCollectProducts);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/epicProduction.ts
// module id = 1932
// module chunks = 3